<script>
    import { slide } from 'svelte/transition';
    
    let showHelpPanel = false;
</script>

<style>
    #help-toggle {
        position: fixed;
        top: 4px;
        right: 4px;
        z-index: 1032;
        border: none;
        color: white;
        font-size: 20px;
    }

    #help-toggle.btn-outline-primary {
        background-color: transparent;
    }

    #help-panel {
        position: fixed;
        height: 338px;
        width: 300px;
        top: 40px;
        right: 2px;
        z-index: 1032;
    }

    #help-panel h1 {
        margin: 0;
        padding: 11px 10px 12px 10px;
        background-color: #3d5980;
        color: white;
        font-size: 15px;
    }

    .help-panel-body-container {
        border: 1px solid #ced4da;
        border-top: none;
        background-color: white;
    }

    .help-panel-body {
        height: 338px;
    }

    .help-panel-body p {
        padding: 5px 10px;
        font-size: 12px;
        margin: 0;
    }

    .help-panel-body h2 {
        margin: 0;
        padding: 7px 10px;
        background-color: #f5f5f5;
        color: #fa8072;
        font-size: 14px;
    }

    #help-panel-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.1); 
        z-index: 1031;
        cursor: default;
    }

    #guides {
        display: flex;
        font-size: 28px;
        padding: 0 40px;
        justify-content: space-around;
    }

    #guides a {
        color: #fa8072 !important;
    }

    video { 
        margin: 10px
    }
</style>

<button id="help-toggle" type="button" on:click={() => showHelpPanel = !showHelpPanel} class="btn focus-outline btn-outline-primary">
    <i class="bi bi-question-circle" />
</button>

{#if showHelpPanel}
    <div transition:slide={{ duration: 300 }} id="help-panel">
        <h1 id="conf-header">Help</h1>
        
        <div class="help-panel-body-container">
            <div class="help-panel-body">
                <h2>Overview</h2>
                <video width="280" controls poster="/assets/docs/AIM_Overview_Frame.jpg">
                    <source src="/assets/docs/AIM_Overview.mp4" type="video/mp4">
                </video>

                <h2>User Guide</h2>
                <p>For a detailed guide on using AIM, please view or download the user guide.</p>
                <div id="guides">
                    <a class="focus-outline" href="/assets/docs/AIM_User_Guide.pdf" target="_blank">
                        <i class="bi bi-box-arrow-up-right" />
                    </a>
                    <a class="focus-outline" href="/assets/docs/AIM_User_Guide.pdf" download>
                        <i class="bi bi-download" />
                    </a>
                </div>
            </div>
        </div>
    </div>
    
    <button class="button-reset" id="help-panel-backdrop" on:click={() => showHelpPanel = false}></button>
{/if}